module.exports = __webpack_public_path__ + "static/media/subscribe-logo.533185a2.png";